module.exports = __webpack_public_path__ + "img/在途中@2x.a5060ea3.png";